import React from 'react';
import {
  Typography,
  Box,
  Paper,
  Button,
  Avatar,
  Stack,
  IconButton,
  Tooltip
} from '@mui/material';
import { styled } from "@mui/system";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

// --- STYLED COMPONENTS ---

// La singola card del certificato
const CertCard = styled(Paper)(({ theme }) => ({
  padding: "16px",
  borderRadius: "12px", // Bordi morbidi
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)", // Ombra leggerissima
  backgroundColor: "#fff",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "8px", // Spazio tra le card
  border: "1px solid transparent",
  "&:hover": {
    transform: "translateY(-2px)", // Effetto lift
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderColor: "#e0e0e0"
  }
}));

// Container per le info testuali
const InfoBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginLeft: "12px",
  marginRight: "auto" // Spinge il bottone a destra
});

export default function CertificateList({ certificates = [], users = [] }) {

  const getUser = (userId) => users.find(u => u.id === userId);
  
  const getInitials = (name) => {
    if (!name) return "?";
    return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
  };

  if (!certificates || certificates.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4, opacity: 0.6 }}>
        <InsertDriveFileIcon sx={{ fontSize: 40, mb: 1, color: '#bdc3c7' }} />
        <Typography variant="body2" color="text.secondary">
          Nessun certificato qui.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={0}> {/* Lo stack gestisce il layout verticale */}
      {certificates.map((cert) => {
        const user = getUser(cert.userId);
        const userName = user ? user.fullName : 'Utente Sconosciuto';
        const expiryDate = cert.expiresAt?.toDate 
          ? cert.expiresAt.toDate().toLocaleDateString() 
          : 'Data N/D';

        return (
          <CertCard key={cert.id} elevation={0}>
            
            {/* 1. AVATAR */}
            <Avatar 
              sx={{ 
                width: 40, 
                height: 40, 
                bgcolor: '#eff0f1', // Grigio chiaro sfondo
                color: '#2d3436', // Testo scuro
                fontSize: '0.9rem',
                fontWeight: 'bold'
              }}
            >
              {getInitials(userName)}
            </Avatar>

            {/* 2. INFO (Nome e Scadenza) */}
            <InfoBox>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                {userName}
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5, opacity: 0.7 }}>
                <CalendarTodayIcon sx={{ fontSize: 12, mr: 0.5 }} />
                <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                  Scade: {expiryDate}
                </Typography>
              </Box>
            </InfoBox>

            {/* 3. AZIONE (Occhio) */}
            <Tooltip title="Vedi file">
              <span> {/* Span serve se il button è disabled per far funzionare il tooltip */}
                <IconButton 
                  size="small"
                  href={cert.certificateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  disabled={!cert.certificateUrl}
                  sx={{ 
                    color: '#a32b2b', // Rosso Corporate
                    bgcolor: 'rgba(163, 43, 43, 0.05)',
                    '&:hover': { bgcolor: 'rgba(163, 43, 43, 0.1)' }
                  }}
                >
                  <VisibilityIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>

          </CertCard>
        );
      })}
    </Stack>
  );
}